import styled from 'styled-components'
import SpSvg from 'components/Icons/sp.svg'
import checkBoxOn from 'components/Icons/checkbox_on.svg'
import checkBoxOff from 'components/Icons/checkbox_off.svg'

const baseUrl = process.env.REACT_APP_COLLECT_URL

export const IconContainer = styled.i`
  &.root {
    background-image: url(${baseUrl}${SpSvg});
    background-size: 380px 320px;
    display: inline-block;
  }

  // 2번줄
  &.check_on {
    background-position: -98px -38px;
    width: 20px;
    height: 20px;
  }

  &.check_off {
    background-position: -128px -38px;
    width: 20px;
    height: 20px;
  }

  &.checkbox_on {
    background-image: url(${baseUrl}${checkBoxOn});
    width: 24px;
    height: 24px;
    background-size: auto;
  }

  &.checkbox_off {
    background-image: url(${baseUrl}${checkBoxOff});
    width: 24px;
    height: 24px;
    background-size: auto;
  }
`
export const StyledSvgG = styled.g.attrs((props) => ({
  fill: props.theme.icon ? props.theme.icon : 'currentColor',
}))``
